import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Table } from 'reactstrap';
import FSObjectListHeader from './FSObjectListHeader';
import FSObjectListItem from './FSObjectListItem';
import FSObjectListDropZone from './FSObjectListDropZone';
import { sortObjectListItems } from './fsObjectUtils';

import NoItems, { ContentType } from 'components/NoItems';

const StyledTable = styled(Table)`
  table-layout: fixed;

  tbody tr {
    td {
      transition: background 0.2s;
    }
    td svg {
      transition: transform 0.2s;
    }

    &:hover {
      td {
        background: #f5fbff;

        &:first-child {
          svg {
            transform: translateX(5px);
          }
        }

        &:last-child {
          button.btn {
            border: 1px solid #767676;
            transform: translateX(-5px);
          }
        }
      }
    }
  }
`;

const TableWrapper = styled.div`
  .table-responsive {
    min-height: 30vh;
  }
`;

const FSObjectList = ({
  items,
  selectedItemIds,
  eventDashOptionsNode,
  onSortChange,
  onItemClick,
  onItemDrop,
  onSelectItem,
  onFilesDrop,
  sorting,
  onArchiveClick,
  onUpdateFolderClick,
  isEventAdmin,
  isLoading,
  onUpdateEventDocClick,
  onEditBroadcastClick,
  onCopyInviteLink,
  onDuplicateBroadcast,
}) => {
  const sortedItems = sortObjectListItems(items, sorting);
  const isEventAdminPred = isEventAdmin
    ? 'Drag and drop or create something new.'
    : 'Check back later';

  return (
    <TableWrapper>
      <StyledTable>
        <FSObjectListHeader
          hasBreadcrumbs
          {...{ eventDashOptionsNode, onSortChange, sorting }}
        />

        {isLoading && !items.length && (
          <NoItems type={ContentType.Files} isLoading={isLoading} />
        )}

        {!items.length && !isLoading && (
          <>
            <FSObjectListDropZone onDrop={onFilesDrop}>
              {() => (
                <NoItems
                  title="You don’t have any... anything!"
                  subTitle={isEventAdminPred}
                  showArrow={isEventAdmin ? true : false}
                  type={ContentType.Files}
                />
              )}
            </FSObjectListDropZone>
          </>
        )}

        <FSObjectListDropZone onDrop={onFilesDrop}>
          {(isDragActive) => (
            <>
              {sortedItems.map((item) => {
                return (
                  <FSObjectListItem
                    key={`fsObjectListItem-${item._id}`}
                    {...{
                      backgroundColor: isDragActive
                        ? 'rgba(0, 149, 255, 0.1)'
                        : 'transparent',
                      selectedItemIds,
                      item,
                      onDrop: onItemDrop,
                      onClick: onItemClick.bind(null, item),
                      onSelectItem: onSelectItem.bind(null, item),
                      onArchiveClick,
                      draggingItemIds: [],
                      onUpdateFolderClick,
                      onUpdateEventDocClick,
                      isEventAdmin,
                      onEditBroadcastClick,
                      onCopyInviteLink,
                      onDuplicateBroadcast,
                    }}
                  />
                );
              })}
            </>
          )}
        </FSObjectListDropZone>
      </StyledTable>
    </TableWrapper>
  );
};

FSObjectList.propTypes = {
  items: PropTypes.array.isRequired,
  selectedItemIds: PropTypes.array.isRequired,
  eventDashOptionsNode: PropTypes.element,
  onSortChange: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onItemDrop: PropTypes.func.isRequired,
  onFilesDrop: PropTypes.func.isRequired,
  sorting: PropTypes.object.isRequired,
  onDuplicateClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onArchiveClick: PropTypes.func.isRequired,
  onUpdateFolderClick: PropTypes.func.isRequired,
  onSaveTemplateClick: PropTypes.func.isRequired,
  onSaveBackupClick: PropTypes.func.isRequired,
  onCopyShowToEvent: PropTypes.func.isRequired,
  isEventAdmin: PropTypes.bool.isRequired,
  isTeamAdmin: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onUpdateEventDocClick: PropTypes.func.isRequired,
  onEditBroadcastClick: PropTypes.func.isRequired,
  onSelectItem: PropTypes.func,
  teamId: PropTypes.string,
  onCopyInviteLink: PropTypes.func,
  onDuplicateBroadcast: PropTypes.func,
};

export default FSObjectList;
